<ix-modal-header id="qrCodeModalHeader" icon="qr-code">
  {{ 'battery_pass.list.qr_code_modal_headline' | translate }}
</ix-modal-header>
<ix-modal-content>
  <div class="qr-code-modal" id="qrCodeModalQrCode">
    {{ 'battery_pass.list.qr_code_modal_content' | translate }}
    @if (activeModal.data) {
      <qrcode
        [margin]="activeModal.data.margin"
        [qrdata]="activeModal.data.data"
        [width]="activeModal.data.width">
      </qrcode>
    }
  </div>
</ix-modal-content>
<ix-modal-footer>
  <ix-button
    (click)="activeModal.dismiss('dismiss')"
    class="close-modal"
    id="qrCodeModalCancelButton"
    onkeypress=""
    variant="secondary">
    {{ 'general.cancel' | translate }}
  </ix-button>
</ix-modal-footer>
